import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Expertise from "@/pages/Expertise";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import FormBuilder from "@/pages/FormBuilder";
import Submissions from "@/pages/Submissions";
import ContentManagement from "@/pages/ContentManagement";
import Campaigns from "@/pages/Campaigns";
import NewsDetail from "@/pages/NewsDetail";
import Cases from "@/pages/Cases";
import CaseForm from "@/pages/CaseForm";
import CaseDetail from "@/pages/CaseDetail";
import Clients from "@/pages/Clients";
import ClientForm from "@/pages/ClientForm";
import People from "@/pages/People";
import Organizations from "@/pages/Organizations";
import Workflows from "@/pages/Workflows";
import Invoices from "@/pages/Invoices";
import Appointments from "@/pages/Appointments";
import AppointmentForm from "@/pages/AppointmentForm";
import AuditLogs from "@/pages/AuditLogs";
import Users from "@/pages/Users";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/form-builder" element={<FormBuilder />} />
          <Route path="/submissions" element={<Submissions />} />
          <Route path="/content" element={<ContentManagement />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/cases/new" element={<CaseForm />} />
          <Route path="/cases/:id/edit" element={<CaseForm />} />
          <Route path="/cases/:id" element={<CaseDetail />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/new" element={<ClientForm />} />
          <Route path="/clients/:id/edit" element={<ClientForm />} />
          <Route path="/people" element={<People />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/workflows" element={<Workflows />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/appointments/new" element={<AppointmentForm />} />
          <Route path="/appointments/:id/edit" element={<AppointmentForm />} />
          <Route path="/audit-logs" element={<AuditLogs />} />
          <Route path="/users" element={<Users />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;